import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import {
  Container,
  ScrollViewWithHeaderTitle,
  theme,
  useNavbarContainerHeight,
  useResponsive,
} from '@sg/garnish';

import { AppFooter } from '../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardConfirmationContainer = (props: PropsWithChildren) => {
  const { children } = props;

  const { currentBreakpoint, match, minWidth } = useResponsive();

  const { paddingBottomStyle: navbarPaddingBottomStyle, paddingTopStyle: navbarPaddingTopStyle } =
    useNavbarContainerHeight();

  // ─── Derived ───────────────────────────────────────────────────────────────

  const shouldApplyNavbarBottomPadding = currentBreakpoint.isXS;
  const shouldApplyNavbarTopPadding = minWidth.isSM;

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = match([styles.containerXS, styles.containerSM]);
  const contentContainerStyles = [
    styles.contentContainerStyle,
    shouldApplyNavbarBottomPadding ? navbarPaddingBottomStyle : undefined,
    shouldApplyNavbarTopPadding ? navbarPaddingTopStyle : undefined,
  ];

  // ─────────────────────────────────────────────────────────────────────────────

  return (
    <ScrollViewWithHeaderTitle contentContainerStyle={contentContainerStyles}>
      <Container style={containerStyles}>{children}</Container>

      {minWidth.isSM ? <AppFooter /> : null}
    </ScrollViewWithHeaderTitle>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  contentContainerStyle: {
    minHeight: '100%',
  },
  containerXS: {
    paddingBottom: theme.spacing['4'],
  },
  containerSM: {
    alignItems: 'center',
    paddingVertical: theme.spacing['12'],
  },
});
